import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { Util } from '../../../config/Util';

function LaunchTraining(arg) {
  const [show, setShow] = useState(arg.flag);
  const [trainingStarted , setTrainingStarted] = useState(false);
  const [counter, setCounter] = useState(0);
  const [finish, setFinish] = useState(false);

  // useEffect(() => {
    
  // }, [])
  

  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);
  const {data} = arg;
  const question = data.trainingData || [];
  //Start training
  const startTraining = ()=>{
    setTrainingStarted(true);
  }
  //Next 
  const handleNextClick =()=>{
    if((counter+1) === question.length) return;
    setCounter(counter+1);
  }
  //Previous
  const handlePreviousClick =()=>{
    if(counter >0) setCounter((counter-1));
  }
  //Finish
  const handleFinishClick=()=>{
    //Call finish api to update the status
    arg.updateStatus();
    setFinish(true);
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false} size="lg">
        <Modal.Header>
          <Modal.Title>Training</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {
                finish && 
                <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Congratulations! You have successfully completed the training - 
                    <b>{data.name}</b>
                    <br></br>
                    {/* <a href={arg.cert} download> Download Certificate</a> */}
                  </Form.Label>
                </Form.Group>
              </Form>
            }
            {
                !trainingStarted && <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Title</Form.Label>
                  <Form.Control value={data.name} type="text" disabled/>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={3} value={data.description} disabled />
                </Form.Group>
                
              </Form>
            }
            {
                (trainingStarted && !finish) && 
                    question.map((q,i)=>{
                        if(i === counter){
                            return(
                            
                                <>
                                <Form key={i}>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label className='text-underline'>Question {i+1} of {question.length}</Form.Label>
                                <br></br>
                                <Form.Label >{q.question}</Form.Label>
                                </Form.Group>
                                <Form.Group
                                className="mb-1"
                                controlId="exampleForm.ControlTextarea1"
                                >
                                <Form.Label>Description :</Form.Label>
                                <Form.Label className='desc-text'>{q.description}</Form.Label>
                                </Form.Group> 
                                <div className='row'>
                                <Form.Group
                                className="mb-3 col-md-6 text-center"
                                controlId="exampleForm.ControlTextarea1"
                                >
                                {/* <Form.Label>Wrong Practice</Form.Label> */}
                                
                                <img  width="300" height="300" src={Util.baseURlForDownload+q.image1}/>
                                <div><Form.Label className='desc-text'>{q.image1Description}</Form.Label></div>
                                </Form.Group>
                                <Form.Group
                                className="mb-3 col-md-6 text-center"
                                controlId="exampleForm.ControlTextarea1"
                                >
                                {/* <Form.Label>Right Practice</Form.Label> */}
                                
                                <img  width="300" height="300" src={Util.baseURlForDownload+q.image2} />
                                <div><Form.Label className='desc-text'>{q.image2Description}</Form.Label></div>
                                </Form.Group>
                                </div>  
                                {/* <div className='row'>
                                  <div className='col-md-6 text-center'><Form.Label className='desc-text'>{q.image1Description}</Form.Label></div>
                                  <div className='col-md-6 text-center'><Form.Label className='desc-text'>{q.image2Description}</Form.Label></div>
                                </div>   */}
                                </Form>
                                <Modal.Footer className='footer-btn-actions'>
                                <Button variant="primary" onClick={handlePreviousClick}>
                                  PREVIOUS
                                </Button>
                                {/* <Button variant="primary" onClick={handleNextClick}>
                                  NEXT
                                </Button> */}
                                {
                                    counter === (question.length-1) ?
                                    <Button variant="success" onClick={handleFinishClick}>
                                    FINISH
                                    </Button> :
                                    <Button variant="primary" onClick={handleNextClick}>
                                    NEXT
                                    </Button>
                                }
                              </Modal.Footer>
                                </>
                        )
                        }
                        
                    })
           
            }
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CLOSE
          </Button>
          {
            !trainingStarted &&   <Button variant="primary" onClick={startTraining}>
            START
          </Button>
          }
            
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LaunchTraining;

